/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iacceptthe2Inputs */

const en_iacceptthe2 = /** @type {(inputs: Iacceptthe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I accept the`)
};

const de_iacceptthe2 = /** @type {(inputs: Iacceptthe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich akzeptiere die`)
};

/**
* | output |
* | --- |
* | "I accept the" |
*
* @param {Iacceptthe2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const iacceptthe2 = /** @type {((inputs?: Iacceptthe2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iacceptthe2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iacceptthe2(inputs)
	return de_iacceptthe2(inputs)
});
export { iacceptthe2 as "iAcceptThe" }